var Schema = require("lib/shared/Schema");
var APIClient = require("lib/web/APIClient");
var ActionUtility = require("lib/shared/ActionUtility");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var Queries = require("lib/shared/Queries");

////////////////////////////////////////
// Quizzes /////////////////////////////
////////////////////////////////////////

export function fetchQuizzes({ filters, conditions, embeds, page, cache }) {
	return (dispatch) => {
		var params = Queries.toQuery(filters, conditions);
		var pagination = { key: $wr.sortedJSON(params), page };
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getQuizzes,
			{ quizzes: [Schema.QUIZ] },
			{ params, embeds, page },
			{ reducer: "quizzes", loading: "index", cache, pagination }));

	}
}

export function deleteQuiz({ id }) {
	return (dispatch) => {
		APIClient.deleteQuiz(id);
		return dispatch({ type: ActionUtility.REMOVE_RECORDS, quizzes: [id] });
	}
}

export function updateQuiz({ id, update, embeds, query }) {
	var params = _.extend({}, query, { quiz: update });

	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, quizzes: [id], update: update });
		// Run this through `ActionUtility.fetchRecords` b/c we sometimes want to load answers
		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchQuiz.bind(null, id),
			{ quiz: Schema.QUIZ },
			{ params, embeds },
			{ reducer: "quizzes", loading: "update" }
		))
	}
}

export function createQuiz({ quiz, embeds }) {
	var params = { quiz: quiz };

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postQuizzes,
			{ quiz: Schema.QUIZ },
			{ embeds, params },
			{ reducer: "quizzes", loading: "create" }
		))
	}
}

////////////////////////////////////////
// Answers /////////////////////////////
////////////////////////////////////////

export function fetchAnswers({ filters, conditions, embeds, page, cache }) {
	return (dispatch) => {
		var params = Queries.toQuery(filters, conditions);
		var pagination = { key: $wr.sortedJSON(params), page };
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getAnswers,
			{ answers: [Schema.ANSWER] },
			{ params, embeds, page },
			{ reducer: "answers", loading: "index", cache, pagination }));
	}
}

export function fetchAnswer({ id, embeds }) {
	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecord(
			APIClient.getAnswer,
			id,
			{ answer: Schema.ANSWER },
			{ embeds },
			{ reducer: "answers", loading: id }));
	}
}

export function fetchNonQuizAnswers({ filters, conditions, embeds, page, cache }) {
	return (dispatch) => {
		var params = Queries.nonQuizAnswerQuery(Queries.toQuery(filters, conditions));
		var pagination = { key: $wr.sortedJSON(params), page };

		return dispatch(ActionUtility.fetchRecords(
			APIClient.getAnswers,
			{ answers: [Schema.ANSWER] },
			{ params, embeds, page },
			{ reducer: "answers", loading: "index", cache, pagination }));

	}
}

export function fetchMetaCognitionAnswers({ filters, conditions, embeds, page, cache }) {
	return (dispatch) => {
		var params = Queries.metaCogAnswerQuery(Queries.toQuery(filters, conditions));
		var pagination = { key: $wr.sortedJSON(params), page };

		return dispatch(ActionUtility.fetchRecords(
			APIClient.getAnswers,
			{ answers: [Schema.ANSWER] },
			{ params, embeds, page },
			{ reducer: "answers", loading: "index", cache, pagination }));

	}
}

export function fetchReviews({ filters, conditions, embeds, page, cache }) {
	return (dispatch) => {
		var params = Queries.reviewQuery(Queries.toQuery(filters, conditions));
		var pagination = { key: $wr.sortedJSON(params), page };
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getAnswers,
			{ answers: [Schema.ANSWER] },
			{ params, embeds, page },
			{ reducer: "answers", loading: "index", cache, pagination }));

	}
}

export function deleteAnswer({ id }) {
	return (dispatch) => {
		dispatch({ type: ActionUtility.REMOVE_RECORDS, answers: [id] });
		return APIClient.deleteAnswer(id);
	}
}

export function updateAnswer({ id, update, embeds, query }) {
	var params = _.extend({}, query, { answer: update });

	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, answers: [id], update: update });
		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchAnswer.bind(null, id),
			{ answer: Schema.ANSWER },
			{ params, embeds },
			{ reducer: "answers", loading: "update" }
		))
	}
}

export function localUpdateAnswer({ id, update }) {
	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, answers: [id], update: update })
		// Theoretically... defer until the change happens? I'm not sure how this works
		return Promise.resolve();
	}
}

export function createAnswer({ answer, embeds }) {
	var params = { answer: answer };
	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postAnswers,
			{ answer: Schema.ANSWER },
			{ embeds, params },
			{ reducer: "answers", loading: "create" }
		))		
	}
}

////////////////////////////////////////
// Evaluations /////////////////////////
////////////////////////////////////////

export function updateEvaluation({ id, update }) {
	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, evaluations: [id], update: update });
		return APIClient.patchEvaluation(id, { evaluation: update });
	}
}

export function fetchEvaluations({ filters, conditions, embeds, page, cache }) {
  return (dispatch) => {
    var params = Queries.toQuery(filters, conditions);
    var pagination = { key: $wr.sortedJSON(params), page };
    return dispatch(
      ActionUtility.fetchRecords(
        APIClient.getEvaluations,
        { evaluations: [Schema.EVALUATION] },
        { params, embeds, page },
        { reducer: "evaluations", loading: "index", cache, pagination }
      )
    )
  };
}

////////////////////////////////////////
// Questions ///////////////////////////
////////////////////////////////////////

export function fetchQuestions({ filters, conditions, query, embeds, page, cache }) {
	return (dispatch) => {
		var params = _.extend(Queries.toQuery(filters, conditions), query);
		var pagination = { key: $wr.sortedJSON(params), page };

		return dispatch(ActionUtility.fetchRecords(
			APIClient.getQuestions,
			{ questions: [Schema.QUESTION] },
			{ params, embeds, page },
			{ reducer: "questions", loading: "index", cache, pagination }));
	}
}


export function createQuestion({ question, embeds, query }) {
	var params = _.extend({}, query, { question: question });
	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postQuestions,
			{ question: Schema.QUESTION },
			{ embeds, params },
			{ reducer: "questions", loading: "create" }
		))
	}
}

export function updateQuestion({ id, update, embeds, query }) {
	var params = _.extend({}, query, { question: update });
	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, questions: [id], update: update });
		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchQuestion.bind(null, id),
			{ deal: Schema.QUESTION },
			{ params, embeds },
			{ reducer: "questions", loading: "update" }
		))
	}
}

export function deleteQuestion({ id }) {
	return (dispatch) => {
		dispatch({ type: ActionUtility.REMOVE_RECORDS, questions: [id] });
		return APIClient.deleteQuestion(id);
	}
}

////////////////////////////////////////
// Comments ////////////////////////////
////////////////////////////////////////

export function fetchComments({ filters, conditions, embeds, page, cache, loadingKey }) {
	loadingKey = loadingKey || "index";
	return (dispatch) => {
		var params = Queries.toQuery(filters, conditions);
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getComments,
			{ comments: [Schema.COMMENT] },
			{ params, embeds, page },
			{ reducer: "comments", loading: loadingKey, cache }));

	}
}

export function updateComment({ id, update, embeds, query }) {
	var params = _.extend({}, query, { comment: update });

	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, comments: [id], update: update });

		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchComment.bind(null, id),
			{ comment: Schema.COMMENT },
			{ params, embeds },
			{ reducer: "comments", loading: "update" }
		))
	}
}

export function createComment({ comment, embeds, query }) {
	var params = _.extend({}, query, { comment });

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postComments,
			{ comment: Schema.COMMENT },
			{ embeds, params },
			{ reducer: "comments", loading: "create" }
		))
	}
}

export function deleteComment({ id, query }) {
	var params = _.extend({}, query);

	return (dispatch) => {
		APIClient.deleteComment(id, query);
		return dispatch({ type: ActionUtility.REMOVE_RECORDS, comments: [id] });
	}
}


////////////////////////////////////////
// Ratings ///////////////////////////////
////////////////////////////////////////

export function fetchRatings({ filters, conditions, embeds, page, cache }) {
	return (dispatch) => {
		var params = Queries.toQuery(filters, conditions);
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getRatings,
			{ ratings: [Schema.RATING] },
			{ params, embeds, page },
			{ reducer: "ratings", loading: "index", cache }));

	}
}

export function updateRating({ id, update, embeds, query }) {
	var params = _.extend({}, query, { rating: update });

	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, ratings: [id], update: update });
		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchRating.bind(null, id),
			{ rating: Schema.RATING },
			{ params, embeds },
			{ reducer: "ratings", loading: "update" }
		))
	}
}

export function deleteRating({ id }) {
	return (dispatch) => {
		dispatch({ type: ActionUtility.REMOVE_RECORDS, ratings: [id] });
		return APIClient.deleteRating(id);
	}
}

export function createRating({ rating, embeds }) {
	var params = { rating: rating };
	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postRatings,
			{ rating: Schema.RATING },
			{ embeds, params },
			{ reducer: "ratings", loading: "create" }
		))		
	}
}

////////////////////////////////////////
// Responses ///////////////////////////
////////////////////////////////////////

export function fetchResponses({ filters, conditions, embeds, page, cache }) {
	return (dispatch) => {
		var params = Queries.toQuery(filters, conditions);
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getResponses,
			{ responses: [Schema.RESPONSE] },
			{ params, embeds, page },
			{ reducer: "responses", loading: "index", cache }));

	}
}

////////////////////////////////////////
// Activities //////////////////////////
////////////////////////////////////////

export const fetchActivity = ({ id, embeds, query, cache }) => {
  const params = { ...query };

  return dispatch =>
    dispatch(
      ActionUtility.fetchRecord(
        APIClient.getActivity,
        id,
        { activity: Schema.ACTIVITY },
        { params, embeds },
        { reducer: "activities", loading: id, cache }
      )
    );
};

export const fetchActivities = ({ filters, conditions, embeds, page, cache }) => {
  const params = Queries.toQuery(filters, conditions);
  const pagination = { key: $wr.sortedJSON(params), page };

  return dispatch =>
    dispatch(
      ActionUtility.fetchRecords(
        APIClient.getActivities,
        { activities: [Schema.ACTIVITY] },
        { params, embeds, page },
        { reducer: "activities", loading: "index", cache, pagination }
      )
    );
};

export const clearActivities = () => (dispatch) => dispatch({ type: ActionUtility.REMOVE_ALL_RECORDS, activities: true });

////////////////////////////////////////
// Tasks ///////////////////////////////
////////////////////////////////////////

export function fetchTasks({ filters, conditions, embeds, page, cache, query }) {
	return (dispatch) => {
		var params = Queries.toQuery(filters, conditions);
		params = { ...query, ...params }

		return dispatch(ActionUtility.fetchRecords(
			APIClient.getTasks,
			{ tasks: [Schema.TASK] },
			{ params, embeds, page },
			{ reducer: "tasks", loading: "index", cache }));

	}
}

export function createTasks({ tasks, query }) {
	var params = _.extend({}, query, { tasks });

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postTasks,
			{ tasks: [Schema.TASK] },
			{ params },
			{ reducer: "tasks", loading: "create" }
		))
	}
}

export function deleteTask({ id }) {
	return (dispatch) => {
		dispatch({ type: ActionUtility.REMOVE_RECORDS, tasks: [id] });
		return APIClient.deleteTask(id);
	}
}

export function deleteManyTasks({ filters, conditions }) {
	return (dispatch, getState) => {
		var tasks = WritingSelectors.tasks({ state: getState(), filters, conditions });

		dispatch({ type: ActionUtility.REMOVE_RECORDS, tasks: _.pluck(tasks, "id") });

		var params = Queries.toQuery(filters, conditions);
		return APIClient.deleteTask("many", params);
	}
}


// WEBPACK FOOTER //
// ./modules/lib/actions/WritingActions.js